export default __webpack_public_path__ + "static/media/element_6.50d53547.avif";